type BrowserStorageName = "localStorage" | "sessionStorage";

function getBrowserStorage(name: BrowserStorageName): Storage | null {
  if (typeof window === "undefined") return null;

  try {
    return window[name];
  } catch {
    return null;
  }
}

function createSafeBrowserStorage(name: BrowserStorageName) {
  return {
    getItem(key: string): string | null {
      try {
        return getBrowserStorage(name)?.getItem(key) ?? null;
      } catch {
        return null;
      }
    },
    setItem(key: string, value: string): boolean {
      try {
        const storage = getBrowserStorage(name);
        if (!storage) return false;
        storage.setItem(key, value);
        return true;
      } catch {
        return false;
      }
    },
    removeItem(key: string): boolean {
      try {
        const storage = getBrowserStorage(name);
        if (!storage) return false;
        storage.removeItem(key);
        return true;
      } catch {
        return false;
      }
    },
    clear(): boolean {
      try {
        const storage = getBrowserStorage(name);
        if (!storage) return false;
        storage.clear();
        return true;
      } catch {
        return false;
      }
    }
  };
}

export const safeLocalStorage = createSafeBrowserStorage("localStorage");
export const safeSessionStorage = createSafeBrowserStorage("sessionStorage");
